export default __webpack_public_path__ + "static/media/img-trabajo-7.fbcee114.jpg";